<template>
  <div class="view--transactions">
    <loader v-if="loader"></loader>

    <header class="header" v-if="!inApp">
      <div class="containter">
        <div class="row justify-content-center">
          <div class="col col-md-6 col-lg-4">
            <nav class="nav">
              <router-link :to="{ name: 'Index' }" tag="div" class="back"><i class="material-icons icon">chevron_left</i></router-link>
              <h1 class="title">{{ $t('transactions.transactions') }}</h1>
            </nav>
          </div>
        </div>
      </div>
    </header>

    <main :class="{ 'in-app': inApp }" v-cloak>
      <section class="section section--transactions">
        <div class="containter">
          <div class="row no-gutters justify-content-center">
            <div class="col col-md-6 col-lg-4">
              <div class="transactions">
                <div
                  class="item"
                  v-for="transaction in transactions"
                  :key="transaction.id"
                >
                  <div
                    class="transaction-row"
                    :class="{ 'has-more': transaction.hasMore }"
                    v-on:click="selectTransaction(transaction)"
                  >
                    <div class="left">
                      <div class="content" v-if="transaction.spend <= 0">
                        {{ $t('transactions.purchaseLogged') }}
                      </div>
                      <div class="content" v-else>
                        {{ $t('transactions.spend', { spend: transaction.spend.toLocaleString() }) }}
                      </div>
                      <div class="time">
                        {{ transaction.time | moment('calendar') }}
                      </div>
                    </div>
                    <div class="right">
                      <div
                        class="detail-toggle"
                        :class="{ 'is-open': transactionDetails[transaction.id] }"
                        v-if="transaction.hasMore"
                      >
                        <div class="toggle-loader" v-if="transactionDetails[transaction.id] === null"><span></span><span></span><span></span></div>
                        <i class="material-icons" v-else>expand_more</i>
                      </div>
                    </div>
                  </div>
                  <transition name="fade">
                    <div class="details" v-if="transactionDetails[transaction.id]">
                      <div
                        class="detail"
                        v-for="(key, index) in transactionDetails[transaction.id]"
                        :key="transactionDetails[transaction.id] + '#' + index"
                      >
                        <div class="name">{{ key.key }}</div>
                        <div class="value" v-html="key.value"></div>
                      </div>
                    </div>
                  </transition>
                </div>
                <div class="item" v-if="transactions.length === 0">
                  <div class="content">{{ $t('transactions.empty') }}</div>
                </div>
                <a
                  class="more"
                  v-if="pagination.currentPage < pagination.total"
                  v-on:click="getAllTransactions(pagination.currentPage + 1)"
                >
                  {{ $t("common.more") }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>

  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex';

import Loader from '@/components/Loader.vue';
import Axios from '@/helpers/axios';

export default {
  name: 'Transactions',
  components: {
    Loader,
  },
  computed: {
    ...mapState([
      'loader',
      'client',
    ]),
    ...mapGetters([
      'inApp',
    ]),
  },
  data() {
    return {
      brand: {
        name: '',
        image: '',
      },
      transactions: [],
      transactionDetails: {},
      pagination: {
        total: 1,
        currentPage: 1,
        perPage: 15,
      },
    };
  },
  methods: {
    ...mapMutations([
      'setLoader',
    ]),
    getAllTransactions(page = 1) {
      const data = {
        ...this.$route.query,
        brand_id: this.$route.params.brand,
        lang: this.$i18n.locale,
        p: this.client.phoneType,
        page,
      };

      Axios({
        method: 'post',
        url: '/v2/ocard/getAllTransactions',
        data,
      })
        .then((response) => {
          const transactions = response.data.data.data.map(transaction => ({
            id: transaction.transId,
            spend: transaction.spend,
            time: transaction.visit_time,
            serial: transaction.ocard_trans_serial,
            hasMore: transaction.hasTransDetail,
          }));

          this.transactions.push(...transactions);

          this.pagination = response.data.data.pagination;

          this.setLoader(false);
        });
    },
    selectTransaction(transaction) {
      if (transaction.hasMore === false) return;

      if (this.transactionDetails[transaction.id]) {
        this.$delete(this.transactionDetails, transaction.id);

        return;
      }

      this.$set(this.transactionDetails, transaction.id, null);

      const data = {
        ...this.$route.query,
        lang: this.$i18n.locale,
        p: this.client.phoneType,
        brand_id: this.$route.params.brand,
        dtk: this.client.dtk,
        transId: transaction.id,
      };

      Axios({
        method: 'post',
        url: '/v2/ocard/getTransactionItemsAndQuantities',
        data,
      })
        .then((response) => {
          // if (response.data.code === 500) {
          this.$set(this.transactionDetails, transaction.id, response.data.data);
          // }
        });
    },
  },
  mounted() {
    this.setLoader(false);

    this.getAllTransactions();
  },
};
</script>

<style lang="sass" scoped>
$cb: cubic-bezier(.4, 0, .2, 1)


.view--transactions
  width: 100%
  height: 100%
  position: relative

.header
  position: fixed
  top: 0
  right: 0
  left: 0
  padding: 12px
  z-index: 1020

  background-color: black

  color: white

  .nav
    display: flex

  .back
    height: 24px
    float: left

    cursor: pointer

    .icon
      width: 36px
      height: 36px

      font-size: 2.25rem
      line-height: 1

  .title
    flex-grow: 1
    margin: 3px 0

    text-shadow: 0 1px 2px rgba(0, 0, 0, .5)
    font-size: 1.2081rem
    font-weight: bold
    text-align: center
    line-height: 28px

  .placeholder
    width: 36px

  .btn
    padding: 0
    height: 34px
    background: transparent

    color: rgba(255, 255, 255, .75)

    vertical-align: middle
    line-height: 34px

    outline: 0

    &:active
      color: rgba(255, 255, 255, .25)

  .material-icons
    margin-right: 4px
    vertical-align: middle

.section-title
  margin: 24px 24px 8px

  color: #686868
  font-size: 0.875rem
  font-weight: bold
  letter-spacing: 2px
  text-transform: uppercase

  & + .section
    margin-top: 0

  &-container
    display: flex
    align-items: center
    margin: 24px 24px 8px

    & + .section
      margin-top: 0

    .section-title
      flex-grow: 1
      margin: 0

main
  padding: 58px 0 80px

  &.in-app
    padding: 0 0 80px

  .transactions
    text-align: center

    .item
      position: relative
      padding: 16px

      text-align: left

      &:not(:last-child)
        &::after
          position: absolute
          top: auto
          right: 24px
          bottom: 0
          left: 24px
          height: 1px

          background-color: #E6E6E6

          content: ''

    .transaction-row
      display: flex
      align-items: center

      &.has-more
        cursor: pointer

    .left
      flex-grow: 1

    .right
      margin-left: 8px

    .detail-toggle
      position: relative
      width: 24px
      height: 24px

      color: rgba(51, 51, 51, .5)

      &.is-open
        transform: rotate(180deg)

      .toggle-loader
        position: absolute
        top: 0
        right: 0
        bottom: 0
        left: 0

        background-color: inherit

        span
          display: inline-block
          width: 4px
          height: 4px
          border-radius: 100%
          background-color: rgba(51, 51, 51, .5)
          margin: 10px 2px
          opacity: 0

          &:nth-child(1)
            animation: opacitychange .5s ease-in-out infinite

          &:nth-child(2)
            animation: opacitychange .5s ease-in-out .166666667s infinite

          &:nth-child(3)
            animation: opacitychange .5s ease-in-out .333333334s infinite

          @keyframes opacitychange
            0%, 100%
              opacity: 0

            60%
              opacity: 1

    .details
      margin-top: 16px
      padding: 8px 16px
      font-size: 0.875rem
      position: relative

      &::after
        position: absolute
        top: 0
        bottom: 0
        left: 0
        width: 3px
        opacity: .1

        border-radius: 0 6px 6px 0

        background-color: #333

        content: ''

    .detail
      display: flex

      &:not(:first-child)
        margin-top: 4px

      .name
        font-weight: bold
        margin-right: 16px
        flex-shrink: 0

      .value
        flex-grow: 1
        white-space: break-spaces
        word-break: break-all

    .more
      margin: 8px auto 0
      padding: 8px 16px
      display: inline-block

      border-radius: 10px

      background: #f5f5f5

      text-align: center
      font-size: 0.75rem
      font-weight: bold
      color: #8E8E8E

      cursor: pointer

    .content
      font-size: 0.875rem

    .time
      margin-top: 6px

    .time
      font-size: 0.75rem
      color: #8E8E8E

.fade-enter-active,
.fade-leave-active
  transition: opacity .25s $cb

.fade-enter,
.fade-leave-to
  opacity: 0
</style>
